import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import { DeviceVerificationMode } from '#src/__generated__/globalTypes.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  AddDeviceMutation,
  AddDeviceMutationVariables,
} from './__generated__/useAddDevice.graphql.ts';

const addDeviceMutation = gql`
  mutation AddDeviceMutation($input: addDeviceInput!) {
    addDevice(input: $input) {
      currentUser {
        slug
        confirmedDevice
      }
      deliveryType
      errors {
        code
        message
        path
      }
    }
  }
` as TypedDocumentNode<AddDeviceMutation, AddDeviceMutationVariables>;

export const useAddDevice = () => {
  const [mutate] = useMutation(addDeviceMutation, {
    showErrorsWithSnackNotification: true,
  });

  return useCallback(
    async () =>
      mutate({
        variables: {
          input: {
            verificationType: DeviceVerificationMode.CODE,
          },
        },
      }).then(({ errors, data }) => {
        return {
          errors: errors || [],
          deliveryType: data?.addDevice?.deliveryType || [],
        };
      }),
    [mutate]
  );
};
